import { ErrorTypes } from 'shared/api';

export const Z_INDEX_MAP = {
    topControls: 20,
    bottomControls: 10
} as const;

export const DEPRECATED_OFFER_ERROR_CODES = [
    ErrorTypes.CandidateOffersNotFound,
    ErrorTypes.NotFound,
    ErrorTypes.OrderNotFound,
    ErrorTypes.EmptyOrderId,
    ErrorTypes.OrderRoleNotFound
];

export const SHIFT_DATE_FORMAT = 'dd MMM, EEE';
export const SHIFT_DATE_FORMAT_WITH_YEAR = 'dd MMM’yy';
export const SHIFT_TIME_FORMAT = 'HH:mm';
